import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";

import { useConfig } from "@/config/ConfigProvider";

export function Footer() {
  const { brand, footer, contact } = useConfig();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[var(--surface-4)] text-[var(--on-dark-fold)]">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 py-14 sm:px-8 sm:py-16 md:grid-cols-[1.4fr_repeat(2,1fr)]">
        <div className="min-w-0">
          <p className="font-heading text-xl font-bold">{brand.logoText || brand.name}</p>
          <p className="mt-3 max-w-sm text-sm opacity-75">{footer.blurb}</p>
          <ul className="mt-6 space-y-3 text-sm">
            <li className="flex items-center gap-3">
              <Phone className="h-4 w-4 shrink-0 opacity-70" aria-hidden />
              <a href={`tel:${brand.phone.replace(/\s+/g, "")}`} className="hover:underline">
                {brand.phone}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-4 w-4 shrink-0 opacity-70" aria-hidden />
              <a href={`mailto:${brand.email}`} className="hover:underline">
                {brand.email}
              </a>
            </li>
            {contact.address ? (
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 opacity-70" aria-hidden />
                <span className="opacity-80">{contact.address}</span>
              </li>
            ) : null}
          </ul>
        </div>

        {footer.columns.map((column) => (
          <div key={column.title} className="min-w-0">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] opacity-60">
              {column.title}
            </p>
            <ul className="mt-4 space-y-2.5 text-sm">
              {column.links.map((link) => (
                <li key={link.label + link.to}>
                  <Link to={link.to} className="opacity-80 hover:opacity-100 hover:underline">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-current/15">
        <div className="mx-auto flex max-w-6xl flex-col gap-2 px-5 py-6 text-xs opacity-70 sm:flex-row sm:items-center sm:justify-between sm:px-8">
          <p>
            &copy; {year} {brand.name}. {footer.legal}
          </p>
          {footer.social.length > 0 ? (
            <ul className="flex gap-4">
              {footer.social.map((item) => (
                <li key={item.href}>
                  <a href={item.href} className="hover:underline" rel="noopener noreferrer">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          ) : null}
        </div>
      </div>
    </footer>
  );
}
